import React, {useContext} from "react";
import PropTypes from "prop-types";
import StyledWeightSelector from "./WeightSelector.styled";
import {replaceZero} from "../../helpers";
import {ThemePramsContext} from "../../App";

const WeightSelector = React.memo(props => {
  const { className, children, onSelectProp, productId, childId, hasRadio, isLarge, outStock } = props;
  const {productDetailsConfig: {productCardConfig}} = useContext(ThemePramsContext);
  return (
    <StyledWeightSelector className={className} outStock={outStock}>
        { children && (hasRadio || children.length > 1) ?
            children.map(item=>
              <button
                className={`weight-selector__weight ${isLarge ? 't-body-medium' : 't-body'} ${childId && item.id === childId ? 'is-active' : (!childId && productId && item.id === productId) ? 'is-active' :''} ${!Number(item.quantity) && children.length > 1 && 'weight-selector__weight__no-quantity'}`}
                key={item.id} 
                onClick={() => onSelectProp(item)}>
                  <span className={`weight-selector__radio ${childId && item.id === childId ? 'is-active' : (!childId && productId && item.id === productId) ? 'is-active' :''} ${!Number(item.quantity) && children.length > 1 && 'weight-selector__radio__no-quantity'}`}/>
                  {item.variation && replaceZero(item.variation)}
              </button>
            )
            :
            children && children.map((item, i)=>
              <p key={i} className={`weight-selector__copy t-body ${productCardConfig.className11}`}>{item.variation && replaceZero(item.variation)}</p>
            )  
        }
    </StyledWeightSelector>
  );
});

WeightSelector.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array,
  onSelectProp: PropTypes.func.isRequired,
  hasRadio: PropTypes.bool,
  isLarge: PropTypes.bool,
  productId: PropTypes.string,
  childId: PropTypes.number,
  outStock: PropTypes.bool,
};

export default WeightSelector;
